import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { tableRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type TableProps = HTMLAttributes<HTMLDivElement> & {
  columns: string
  overline: string
  tables: {
    table: {
      title: string
      rows: {
        left: string
        right: string
      }[]
    }
  }[]
}

const Table = ({ columns, overline, tables, ...props }: TableProps) => {
  return (
    <Motion animation={tableRevealAnimation}>
      <Section {...props}>
        <Container>
          <div className="flex flex-col gap-spacing-lg">
            <Typography variant="overline" className="normal-case">
              {overline}
            </Typography>
            <Grid className="gap-spacing-lg">
              {tables.map((table, index) => (
                <div
                  key={index}
                  className={cn(
                    'col-span-4 flex flex-col md:col-span-6',
                    columns === '2' ? 'lg:col-span-6' : 'lg:col-span-12'
                  )}
                >
                  <div className="flex pb-spacing-sm">
                    <Typography variant="large" className="font-medium">
                      {table.table.title}
                    </Typography>
                  </div>
                  {table.table.rows.map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className="relative grid grid-cols-4 justify-between gap-spacing-sm py-spacing-sm md:grid-cols-3"
                      data-motion-table-row
                    >
                      <hr className="absolute left-0 top-0 w-full origin-left border-t border-t-white-dark/30" />
                      <div className="col-span-2 flex items-center md:col-span-1">
                        <Typography
                          variant="regular"
                          className="font-bold text-text-secondary-dark"
                        >
                          {row.left}
                        </Typography>
                      </div>
                      <div className="col-span-2 flex items-center md:col-span-2">
                        <Typography variant="small">{row.right}</Typography>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </Grid>
          </div>
        </Container>
      </Section>
    </Motion>
  )
}

export default Table
